import { useEffect } from 'react';

import { useNavigate, useSearch } from '@tanstack/react-router';

import { useSheetStore } from '@/shared/stores/sheet-store';

export function useOpenSheetFromSearch() {
    const search = useSearch({ from: '/dashboard' });
    const navigate = useNavigate();
    const openSheet = useSheetStore((state) => state.openSheet);

    useEffect(() => {
        if (search.openSheet === 'sessions/today') {
            openSheet({ type: 'sessions/today', label: "Today's Sessions" });
            void navigate({ to: '/dashboard', search: {}, replace: true });
        }
    }, [search.openSheet, openSheet, navigate]);
}
